import {createElement} from 'react';
import {getElementAttributes} from 'helpers';
import css from 'components/ui/common.module.scss';

export function Text({ children, className, ...props }) {
  return Boolean(children) && createElement('pre', {
    ...getElementAttributes(props),
    children: filter(children),
    className: css(className, /\S{30,}/.test(children) && 'has-long-text'),
    style: {color: props.color},
  });
}

function filter(string) {
  if (typeof string == 'string') {
    return wrapLinks(string);
  }
  return string;
}

function wrapLinks(string) {
  const split = string.split(/https?:\S+/);
  const links = [...string.matchAll(/https?:\S+/g)];
  return split.map((bit, index) => [ bit, links[index] && createElement('span', {
    children: links[index],
    className: 'link',
    key: bit + index,
    onClick,
  }) ]);
}

function onClick(link) {
  link.preventDefault();
  const url = link.target.innerHTML;
  const dom = document.createElement('a');
  dom.href = url;
  dom.target = '_blank';
  dom.click();
}
